module.exports = __webpack_public_path__ + "img/mafalda_sousa.ae8b3a91.jpg";